import {useQuery} from '@tanstack/react-query';
import * as E from 'fp-ts/lib/Either';
import {useMemo} from 'react';

import {fetchConfig} from '../../../helpers/http';
import {useSurveyRouterData} from '../../survey/surveyRoutesHelpers';
import {defaultSurveyConfig, userDefinedSurveyConfigCodec} from './config';

/*
 * Hook.
 */

export const useUserDefinedSurveyConfig = (isPreview: boolean) => {
  const routerData = useSurveyRouterData();
  const {data, isLoading} = useQuery(['surveyConfig', routerData.slug], fetchConfig, {
    retry: false,
    refetchOnWindowFocus: isPreview,
    enabled: !!routerData.slug,
  });

  const validConfig = useMemo(() => {
    if (!data) {
      return defaultSurveyConfig;
    }

    const result = userDefinedSurveyConfigCodec.decode(data);

    return E.getOrElse(() => defaultSurveyConfig)(result);
  }, [data]);

  return {
    config: validConfig,
    isLoading,
  };
};
